/* eslint-disable */ 
import React, { useState } from 'react'
import { useDispatch } from 'react-redux';
import { Field, FieldArray, reduxForm, change} from 'redux-form'
import styles from './Forms.css'
import InputLabel from '@material-ui/core/InputLabel'
import SelectField from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem'
import FormControl from '@material-ui/core/FormControl'
import Link from '@material-ui/core/Link'
import { withStyles } from '@material-ui/core/styles'
import MaskedInput from '../../containers/Forms/components/MaskedInput'
import CheckboxInput from '../../containers/Forms/components/CheckboxInput'
import {
  emailMask,
  requiredValidation,
  emailValidation,
  minLen1Validation,
  phoneValidationWith1Prefix,
} from '../../containers/Forms/components/formValidations'
import TextInput from '../../containers/Forms/components/TextInput'
import Loading from '../../components/Loading'
import pluseIcon from 'static/images/Vector.png'
import { countryList, RegionList } from './constants'
import { FormattedMessage } from 'react-intl'


const NewMemberForm = props => {
  const [ required, setRequired] = useState(false);
  const dispatch = useDispatch();
  const {
    handleSubmit,
    invalid,
    pristine,
    submitting,
    isSubmitting,
    showTKFeatureEnabled,
    inviteMemberFormValues,
  } = props

  // common array for all selected country and region. 
  let allCountryRegionArray = [];

  // getting values from counrty and region field from teh form.
  if(inviteMemberFormValues && inviteMemberFormValues.region){
    allCountryRegionArray.push({
      country: inviteMemberFormValues.country || '',
      region: inviteMemberFormValues.region
    })
  }

  // geeting values form the members array and combine to the allCountryRegionArray
  if (inviteMemberFormValues && inviteMemberFormValues.members && inviteMemberFormValues.members.length > 0 ){
    allCountryRegionArray =[...allCountryRegionArray, ...inviteMemberFormValues.members]
  }

  const RegionListRemoveSelected =  RegionList.filter(function(cv){
    return !allCountryRegionArray.find(function(er){
        return er.region == cv.value;
    });
});

  const renderSelectField = withStyles({
    select: {
      // height: '10px',
    },
  })(({
    input,
    label,
    meta: { touched, error },
    children,
    ...custom
  }) => (
    <FormControl size="small" variant="outlined">
      <InputLabel>{label}</InputLabel>
      <SelectField
        floatingLabelText={label}
        errorText={touched && error}
        className={styles.selectFieldStyle}
        {...input}
        // eslint-disable-next-line react/no-children-prop
        children={children}
        {...custom}
      />
   {!input.value ? setRequired(true) : setRequired(false)}      
   {!input.value && <span className={styles.error}><FormattedMessage id="validation.message.Required" /></span>}
    </FormControl>
  ))

  const renderMembers = temp => (
    <ul>
      <li className={ inviteMemberFormValues && inviteMemberFormValues.region === null && inviteMemberFormValues.country === null ? styles.displayNone : styles.editDropdown} >
        <div>
          <InputLabel className={styles.labelColorDropdown}><FormattedMessage id="label.Country" /></InputLabel>
          <Field
            name="country"
            component={renderSelectField}
            // validate={[ requiredValidation ]}
            // label="Country"
          >
            {
              countryList.map((item, i) => <MenuItem key={i} value={item.value}>{item.name}</MenuItem>)
            }
          </Field>

        </div>
        <div>

          <InputLabel className={styles.labelColorDropdown}><FormattedMessage id="label.Region" /></InputLabel>
          <Field
            name="region"
            component={renderSelectField}
            // validate={[ requiredValidation ]}
            // label="Region"
          >
            {
              RegionList.map((item, i) => <MenuItem key={i} disabled = {allCountryRegionArray.find(function(rr){
                return (rr.region == item.value ? true : false)
            })}  value={item.value}>{item.name}</MenuItem>)
            }
          </Field>
        </div>
        <div style={{ marginTop: 34 }}>
        <Link href="#" style={{ marginLeft: 8 }} className={temp.fields.length === 0 ? styles.buttonVisibleMyinfo : styles.buttonCss} onClick={
          () => {
            dispatch(change('addNewMemberForm','region', null)); dispatch(change('addNewMemberForm','country', null))
          }
          }>
            <FormattedMessage id="button.remove" />
            </Link>
          <img style={{ marginTop: -6 }} className={temp.fields.length === 0 ? styles.buttonCss : styles.buttonVisibleMyinfo} src={pluseIcon} alt="add button"/>
          <Link style={{ marginLeft: 8 }} href="#" className={temp.fields.length === 0 ? styles.buttonCss : styles.buttonVisibleMyinfo} onClick={() => temp.fields.push({})}>
            <FormattedMessage id="button.add_location" />
          </Link>
        </div>
        {/* {submitFailed && error && <span>{error}</span>} */}
      </li>
      {temp.fields.map((member, index) => (
        <li className={styles.editDropdown} key={index}>
        <div>
            <InputLabel className={styles.labelColorDropdown}><FormattedMessage id="label.Country" /></InputLabel>
            <Field
              name={`${member}.country`}
              component={renderSelectField}
              // validate={[ requiredValidation ]}
              // label="Country"
            >
              {
                countryList.map((item, i) => <MenuItem key={i} value={item.value}>{item.name}</MenuItem>)
              }
            </Field>
          </div>
          <div>
            <InputLabel className={styles.labelColorDropdown}><FormattedMessage id="label.Region" /></InputLabel>
            <Field
              name={`${member}.region`}
              component={renderSelectField}
              // validate={[ requiredValidation ]}
              // label="Region"
            >
              {
                RegionList.map((item, i) => <MenuItem 
                key={i}
                disabled = {allCountryRegionArray.find(function(r){
                  return (r.region == item.value ? true : false)
              })}  
                value={item.value}>
              {item.name}
              </MenuItem>)
              }
            </Field>
          </div>
          <div style={{ marginTop: 34 }}>
          <Link href="#" style={{ marginLeft: 8 }} className={(temp.fields.length > 0) && (temp.fields.length === index) ? styles.buttonVisibleMyinfo : styles.buttonCss } onClick={() => temp.fields.remove(index)}>
            <FormattedMessage id="button.remove" />
            </Link>
          </div>
        </li>))}
         {temp.fields.map((member, index) => (
        <div style={{ marginTop: 14 }}>
        <img style={{ marginTop: -6 }} className={(temp.fields.length > 0) && (temp.fields.length - 1 === index) ? styles.buttonCss : styles.buttonVisibleMyinfo} src={pluseIcon} alt="add button"/>
        <Link href="#" style={{ marginLeft: 8 }} className={(temp.fields.length > 0) && (temp.fields.length - 1 === index) ? styles.buttonCss : styles.buttonVisibleMyinfo} onClick={() => temp.fields.push({})}>
          <FormattedMessage id="button.add_location" />
        </Link>
      </div>))}
    </ul>
  )

  return (
    <form onSubmit={handleSubmit}>
      <div className={styles.formSection}>
        <div className={styles.formSectionRow}>
          {
            (showTKFeatureEnabled || showCRPFeatureEnabled) && (

              <React.Fragment>

                <div className={styles.editLabelGroup}>
                  <Field
                    component={TextInput}
                    label="First Name"
                    name="firstName"
                    placeholder="Enter First Name"
                    // required={true}
                    // validate={[ minLen1Validation, requiredValidation ]}
                  />
                </div>
                <div className={styles.editLabelGroup}>
                  <Field
                    component={TextInput}
                    label="Last Name"
                    name="lastName"
                    placeholder="Enter Last Name"
                    // required={true}
                    // validate={[ minLen1Validation, requiredValidation ]}
                  />
                </div>
                <div className={styles.editLabelGroup}>
                  <Field
                    component={TextInput}
                    label="Phone"
                    name="phone"
                    placeholder="Enter phone no"
                    required={true}
                    validate={[ phoneValidationWith1Prefix, requiredValidation ]}
                    type={"number"}
                  />
                </div>
              </React.Fragment>

            )
          }
          <div className={styles.editLabelGroup}>
            <Field
              component={MaskedInput}
              mask={emailMask}
              placeholder="name@example.com"
              label="Email"
              name="email"
              required={true}
              validate={[ emailValidation, minLen1Validation, requiredValidation ]}
            />
          </div>
          {/* <div className={styles.placeholder} />
          <div className={styles.placeholder} /> */}
        </div>
        {
          (showTKFeatureEnabled || showCRPFeatureEnabled) && (
            <React.Fragment>
              <div style={{ marginTop: 15 }}>
                {/* <InputLabel>Country</InputLabel> */}
                <div className={styles.editDropdown}>
                  <FieldArray name="members" component={renderMembers} />
                </div>
              </div>
            </React.Fragment>
          )
        }
      </div>
      <h2 className={styles.formTitle}><FormattedMessage id="heading.Member_Roles" /></h2>
      <div className={styles.formSection}>
        <div className={styles.formSectionRow}>
          <div className={styles.checkboxWithDesc}>
            <Field
              component={CheckboxInput}
              label="Account Administrator"
              name="isAdmin"
            />
            <p className={styles.description}><FormattedMessage id="description.account_adminster" /></p>
          </div>
          <div className={styles.checkboxWithDesc}>
            <Field
              component={CheckboxInput}
              label="Provider"
              name="isPhysician"
            />
            <p className={styles.description}><FormattedMessage id="description.provider" /></p>
          </div>
          <div className={styles.placeholder} />
        </div>
      </div>
      <div className={styles.submitWrapper}>
        <div className={styles.buttonWrapper}>
          {!pristine && (submitting || isSubmitting) ?
            <button disabled className={styles.submitLoading}>
              <Loading />
            </button>
            :
            <button type="submit" disabled={invalid || pristine || required} className={styles.submit}>
              <FormattedMessage id="button.send_invite" />
            </button>
          }
        </div>
      </div>
    </form>
  )
}

export default reduxForm({
  form: 'addNewMemberForm',
})(NewMemberForm)



// WEBPACK FOOTER //
// ./src/legacy/containers/Forms/NewMemberForm.jsx